<div class="p-6 w-full">
  <div class="header-section">
    <nav class="inter flex items-center space-x-2 text-sm text-gray-700 mb-4">
      <span class="material-symbols-outlined" style="font-size: 18px;">home</span>
      <span class="text-[14px] font-medium color-[#374151] cursor-pointer" (click)="navigateToMenu()">Home</span>
      <span class="material-symbols-outlined">arrow_forward_ios</span>
      <span class="text-[14px] font-medium color-[#374151]">Sistemas</span>
    </nav>
    <h1 class="text-[28px] font-medium text-black w-fit">Sistemas</h1>
  </div>

    <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center">
      <div class="md:w-64 mt-8 mb-4">
        <app-custom-search
          placeholder="Buscar"
          backgroundColor="#ffffff"
          textColor="#374151"
          iconColor="#9ca3af"
          borderColor="#e1e5e9"
          focusBorderColor="#3b82f6"
          [showClearButton]="false"
          [(ngModel)]="searchText"
          (keyup)="onSearchKeyup($event)">
        </app-custom-search>
      </div>
      <div class="flex flex-col md:flex-row gap-3 lg:mt-6 mb-4 lg:mb-0">
        <app-custom-button
          text="Exportar excel"
          backgroundColor="#5CA42F"
          borderColor="#5CA42F"
          size="md"
          icon='<span class="material-symbols-outlined">file_save</span>'
          iconPosition="left"
          hoverBackgroundColor="#487F25"
          hoverTextColor="#ffffff"
          (click)="exportarExcel()">
        </app-custom-button>


        <app-custom-button
          text="Agregar sistema"
          backgroundColor="#005FFF"
          borderColor="#005FFF"
          size="md"
          icon='<span class="material-symbols-outlined">add</span>'
          iconPosition="left"
          hoverBackgroundColor="#0549BD"
          hoverTextColor="#ffffff"
          (click)="onAddSystem()">
        </app-custom-button>
      </div>
    </div>

  <!-- Tabla -->

    <mat-card>
      <mat-card-content class="!p-0 bg-white">
        <div class="flex-1 overflow-x-auto!">
          <table mat-table [dataSource]="dataSource" matSort>

            <!-- NOMBRE -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef class="text-white"  mat-sort-header>NOMBRE</th>
              <td mat-cell *matCellDef="let element" [title]="element.nombre">{{element.nombre}}</td>
            </ng-container>

            <!-- DESCRIPCIÓN -->
            <ng-container matColumnDef="descripcion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPCIÓN</th>
              <td mat-cell *matCellDef="let element" [title]="element.descripcion">{{element.descripcion}}</td>
            </ng-container>

            <!-- RUTA -->
            <ng-container matColumnDef="ruta">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>RUTA</th>
              <td mat-cell *matCellDef="let element" [title]="element.ruta">{{element.ruta}}</td>
            </ng-container>

            <!-- ICONO -->
            <ng-container matColumnDef="icono">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ICONO</th>
              <td mat-cell *matCellDef="let element" [title]="element.icono">{{element.icono}}</td>
            </ng-container>

            <!-- ORDEN -->
            <ng-container matColumnDef="orden">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ORDEN</th>
              <td mat-cell *matCellDef="let element" [title]="element.orden">{{element.orden}}</td>
            </ng-container>


            <!-- Acción -->
            <ng-container matColumnDef="accion">
              <th mat-header-cell *matHeaderCellDef>EDITAR</th>
              <td mat-cell *matCellDef="let sistema">
                <div class="flex gap-1 items-center justify-left">
                  <button mat-icon-button (click)="onOpenModalEditUser(sistema)">
                    <span class="material-symbols-outlined" style="font-size: 18px; font-variation-settings: 'opsz' 18;color: #6B7280;">
                      edit_square
                    </span>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- Header y Body -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50 transition-colors duration-150"></tr>
          </table>
        </div>

        <!-- Paginador -->
        <mat-paginator [pageSizeOptions]="[10, 25, 100]" [showFirstLastButtons]="false"></mat-paginator>
      </mat-card-content>
    </mat-card>


  <!-- 👇 Componente de Modal -->
  <app-custom-modal
    [isOpen]="isModalOpen"
    title="Agregar Nuevo Sistema"
    [buttons]="[{ text: 'Agregar', variant: 'primary', action: 'save', variantCancel:'info' }]"
    (close)="closeModal()"
    (buttonClick)="saveSystem()">

    <div class="w-full h-full p-4">
      <form [formGroup]="sistemaForm" class="flex flex-col gap-4">

        <!-- Campo para el nombre del sistema -->
        <app-input-custom
          label="Nombre del Sistema"
          formControlName="nombre"
          [hasError]="(nombre?.errors?.['required'] || nombre?.errors?.['maxlength']) && submitted"
        />

        <!-- Mensaje de error -->
        @if (submitted && nombre?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            El nombre del sistema es obligatorio.
          </p>
        }
        @if (submitted && nombre?.errors?.['maxlength']) {
          <p class="text-red-600 text-sm font-normal">
            El nombre del sistema no puede tener más de 60 caracteres.
          </p>
        }

      </form>
    </div>
  </app-custom-modal>

  <!-- 👇 Componente de Modal -->
  <app-custom-modal
    [isOpen]="isModalOpenEdit"
    title="Editar Sistema"
    [buttons]="[{ text: 'Editar', variant: 'primary', action: 'save', variantCancel:'info' }]"
    (close)="closeModal()"
    (buttonClick)="editSaveSystem()">

    <div class="w-full h-full p-4">
      <form [formGroup]="sistemaEditForm" class="flex flex-col gap-4">
        <!-- Campo para el nombre del sistema -->
        <app-input-custom
          label="Nombre"
          formControlName="nombreEdit"
          [hasError]="(nombreEdit?.errors?.['required'] || nombreEdit?.errors?.['maxlength']) && submitted"
        />

        <!-- Mensaje de error -->
        @if (submitted && nombreEdit?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            El nombre del sistema es obligatorio.
          </p>
        }
        @if (submitted && nombreEdit?.errors?.['maxlength']) {
          <p class="text-red-600 text-sm font-normal">
            El nombre del sistema no puede tener más de 30 caracteres.
          </p>
        }

        <!-- Campo para el descripción del sistema -->
        <app-input-custom
          label="Descripción"
          formControlName="descripcion"
          [hasError]="(descripcion?.errors?.['required'] || descripcion?.errors?.['maxlength']) && submitted"
        />

        <!-- Mensaje de error -->
        @if (submitted && descripcion?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            La descripción del sistema es obligatorio.
          </p>
        }
        @if (submitted && descripcion?.errors?.['maxlength']) {
          <p class="text-red-600 text-sm font-normal">
            La descripción del sistema no puede tener más de 100 caracteres.
          </p>
        }

        <!-- Campo para ruta del sistema -->
        <app-input-custom
          label="Ruta"
          formControlName="ruta"
          [hasError]="(ruta?.errors?.['required'] || ruta?.errors?.['maxlength']) && submitted"
        />

        <!-- Mensaje de error -->
        @if (submitted && ruta?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            La ruta del sistema es obligatorio.
          </p>
        }
        @if (submitted && ruta?.errors?.['maxlength']) {
          <p class="text-red-600 text-sm font-normal">
            La ruta del sistema no puede tener más de 300 caracteres.
          </p>
        }

        <!-- Campo para icono del sistema -->
        <app-input-custom
          label="Icono"
          formControlName="icono"
          [hasError]="(icono?.errors?.['required'] || icono?.errors?.['maxlength']) && submitted"
        />

        <!-- Mensaje de error -->
        @if (submitted && icono?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            La icono del sistema es obligatorio.
          </p>
        }
        @if (submitted && icono?.errors?.['maxlength']) {
          <p class="text-red-600 text-sm font-normal">
            La icono del sistema no puede tener más de 40 caracteres.
          </p>
        }

        <!-- Campo para orden del sistema -->
        <app-input-custom
          label="Orden"
          formControlName="orden"
          [hasError]="(orden?.errors?.['required'] || orden?.errors?.['pattern'] || orden?.errors?.['max']) && submitted"
        />

        <!-- Mensaje de error -->
        @if (submitted && orden?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            El orden del sistema es obligatorio.
          </p>
        }
        @if (submitted && orden?.errors?.['pattern']) {
          <p class="text-red-600 text-sm font-normal">
            El campo solo puede contener números.
          </p>
        }
        @if (submitted && orden?.errors?.['max']) {
          <p class="text-red-600 text-sm font-normal">
            El orden no puede ser mayor a 9999999.
          </p>
        }
        <div>
          <span class="text-[#374151] text-xl font-semibold">Subir imagen</span>
        </div>
        <div class="bg-[#E2EBFC] rounded-lg p-4 text-start">
          <p class="text-[#005FFF] text-sm font-medium">
            Se recomienda que la imagen sea cuadrada
          </p>
        </div>
        <div class="flex flex-col">
          <div class="flex items-center content-center min-h-[200px] gap-x-6">
            @if (!uploadFile) {
              <div
                class="relative flex flex-col outline-gray-500 outline-2 -outline-offset-4 outline-dashed w-full h-[200px] items-center justify-center"
              >
                <input
                  #fileInput
                  type="file"
                  accept="image/x-png,image/gif,image/jpeg"
                  (change)="getBase64($event)"
                  class="absolute w-50 h-full cursor-pointer opacity-0 top-0 left-0"
                />

                <span class="mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-10 h-10">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
                  </svg>
                </span>

                <p class="text-center text-sm font-normal max-w-[90%] text-[#6B7280]">
                  Click para subir o arrastrar y soltar <br />
                  PNG (MAX. 10mb)
                </p>

              </div>
            }
            @if (uploadFile) {
              <div
                class="flex flex-col w-full h-auto items-center relative overflow-hidden bg-white"
              >
                <!--<img [src]="sistemaSelected.img" class="w-50 object-contain " alt="Vista previa de la imagen">-->
                <img [src]="sistemaEditForm.get('img')?.value" class="w-50 object-contain " alt="Vista previa de la imagen">

                <div class="flex flex-col w-full p-4 bg-white text-center">
                  <p class="mb-6">{{ fileName }}</p>

                  <div class="flex gap-3 justify-start">
                    <button
                      type="button"
                      [disabled]="isUploading"
                      (click)="handleRemovesFile()"
                      class="cursor-pointer text-sm font-medium w-[100%] border border-red-500 px-4 py-3 rounded-lg text-red-500 hover:bg-red-500 hover:text-white ease-in-out"
                    >
                      ELIMINAR
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

      </form>
    </div>
  </app-custom-modal>


</div>
